<template>
  <v-card class="global-card">
    <v-card-title>
      <h3>Tasks</h3>
    </v-card-title>
    <v-card-text class="booked-camps">
      <v-list two-line v-if="tasks.length > 0">
        <v-list-item-group>
          <!-- <template >
            <section > -->
          <v-list-item
            v-for="item in tasks"
            :key="item.index"
            @click="showTaskDetails(item)"
          >
            <v-list-item-content>
              <v-list-item-title v-text="item.subject"></v-list-item-title>
              <v-list-item-subtitle>
                <read-more
                  more-str=""
                  :text="item.notes || '---'"
                  :max-chars="20"
                  class="m-b-0"
                ></read-more>
              </v-list-item-subtitle>
            </v-list-item-content>
            <!-- <v-spacer></v-spacer> -->
            <v-list-item-content
              class="text-center"
              :class="item.task_status.name"
            >
              <span>{{
                item.task_status ? item.task_status.name : "---"
              }}</span>
            </v-list-item-content>
            <v-list-item-action>
              <v-list-item-action-text
                v-text="item.due_date ? item.due_date.date : '---'"
              ></v-list-item-action-text>
            </v-list-item-action>
            <v-divider
              v-if="item.index + 1 < tasks.length"
              :key="item.index"
            ></v-divider>
          </v-list-item>
          <!-- </section> -->

          <!-- </template> -->
        </v-list-item-group>
      </v-list>
      <h2 class="text-center py-10" v-else>No Tasks yet.</h2>
    </v-card-text>

    <v-dialog v-model="dialog" width="500">
      <v-card class="global-card pa-5">
        <v-card-title class="font-bold pa-0" primary-title>
          <h3>
            <span>{{ tasksData.subject }}</span>
          </h3>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-card-title>
        <p class="mb-0 pb-0">{{ `#` + tasksData.serial }}</p>
        <h5 class="py-4">
          {{ tasksData.due_date ? tasksData.due_date.date : "--" }}
        </h5>
        <v-card-text class="px-0">
          <v-row>
            <v-col cols="4">
              <span>Mobile Number :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{ tasksData.mobile }}</span>
            </v-col>
            <v-col cols="4">
              <span>Task Type :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                tasksData.task_type ? tasksData.task_type.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Agent :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                tasksData.creator ? tasksData.creator.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Product Type :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                tasksData.product_type ? tasksData.product_type.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Task Status :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark">{{
                tasksData.task_status ? tasksData.task_status.name : "---"
              }}</span>
            </v-col>
            <v-col cols="4">
              <span>Escalation Level :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark" v-if="tasksData.escalation_level === 0"
                >Never Escalated</span
              >
              <span
                class="color-dark"
                v-else-if="tasksData.escalation_level === 1"
                >Escalated Level One</span
              >
              <span class="color-dark" v-else>Escalated Level Two</span>
            </v-col>
            <v-col cols="4">
              <span>Notes :</span>
            </v-col>
            <v-col cols="8">
              <span class="color-dark" v-html="tasksData.notes || '---'"></span>
            </v-col>
            <v-col cols="3" class="mx-auto">
              <v-btn
                class="button btn-height--1 mt-8 mx-1"
                color="success"
                rounded
                @click="dialog = false"
              >
                <span class="mx-2">Ok</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { ShowData } from "@/helpers/apiMethods";

export default {
  data() {
    return {
      tasksData: [],
      currentTaskSerial: null,
      dialog: false
    };
  },
  props: {
    tasks: {
      type: Array,
      default: () => {}
    }
  },
  methods: {
    showTaskDetails({ serial }) {
      this.currentTaskSerial = serial;
      this.getTaskData();
      setTimeout(() => {
        this.dialog = true;
      }, 500);
    },
    getTaskData() {
      ShowData({
        reqName: `crm/tasks`,
        id: this.currentTaskSerial
      })
        .then(res => {
          // this.loadingInteraction = false;
          const { task } = res.data;
          this.tasksData = task;
        })
        .catch(() => {});
    }
  }
};
</script>
